
export const Redirect = ({ element }) => {
    const token = localStorage.getItem("token");

    if (token) { window.location = "/" }
    else{
        return element;
    }
    
}